import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminServiceHandle.css';
import maintenanceImage from '../../assets/images/UnderMaintenance.jpg'; // ✅ make sure the path is correct

const AdminServiceHandle = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-service-down-container">
      <div className="image-box">
        <img src={maintenanceImage} alt="Service Under Maintenance" className="maintenance-image" />
        <div className="message">
          <h1>🚧 Admin Service Down</h1>
          <p>We’re currently performing some maintenance.<br />Please check back shortly.</p>
          <button onClick={() => navigate('/admin/dashboard')}>
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminServiceHandle;
